import type { ReactElement } from 'react';

interface TabProgressProps {
  pct: number;
  maxPct: number;
}

export default function TabProgress({
  pct,
  maxPct,
}: TabProgressProps): ReactElement {
  const clamped = Math.max(0, Math.min(pct, maxPct));
  const percentage = maxPct > 0 ? (clamped / maxPct) * 100 : 0;
  const getProgressColor = (pct: number): string => {
    if (pct === 0) return 'bg-gray-400';
    if (pct < 34) return 'bg-red-500';
    if (pct < 67) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const color = getProgressColor(percentage);
  const displayText = clamped > 0 ? `${clamped.toFixed(1)}%` : '0%';

  return (
    <div className="w-full border-2 border-blue-300">
      <div className="flex justify-between text-xs text-gray-600 mb-1">
        <span className="font-medium">{displayText}</span>
        <span className="text-gray-500 ">de {maxPct.toFixed(1)}%</span>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className={`h-2 rounded-full transition-all duration-500 ease-out ${color}`}
          style={{
            width: `${Math.max(0.5, percentage).toFixed(2)}%`,
            minWidth: percentage > 0 ? '2px' : '0px',
          }}
        />
      </div>

      {/* Debug visible */}
      {/* <div className="text-xs text-red-600 mt-1 font-mono bg-red-50 p-1">
        DEBUG: {pct.toFixed(2)} / {maxPct.toFixed(2)} = {percentage.toFixed(1)}%
      </div> */}
    </div>
  );
}
